export default {
  dbi_market: 'Market',
  dbi_market_profile: 'Market Profile',
  dbi_market_annual_report: 'Annual Report',
  dbi_market_global_perf: 'Global Performance',
  dbi_market_dataai: 'The data is directely from data.ai market size endpoint.',
  dbi_market_newzoo_rev:
    'Shown here is internally generated total annual revenue, applying only the year in the time filter.',
  dbi_market_newzoo_player:
    'Shown here is internally generated total annual downloads, applying only the year in the time filter.',
  dbi_market_global_sum: 'Global Game Market Summary',
  dbi_market_distribution: 'Global Game Market Distribution',
  dbi_market_game_count: 'Game Count',
  dbi_market_gdp: 'Nominal GDP',
  dbi_market_gdp_per: 'GDP Per Capita',
  dbi_market_gdp_intro:
    "Per capita gross domestic product (GDP) is a financial metric that breaks down a country's economic output per person and is calculated by dividing the GDP of a nation by its population.",
  dbi_market_total_pop: 'Total Population',
  dbi_market_online_pop: 'Online Population',
  dbi_market_total: 'Total Market',
  dbi_market_mobile: 'Mobile Game Market',
  dbi_market_pc: 'PC Game Market',
  dbi_market_console: 'Console Game Market',
  dbi_mobile_game: 'Mobile Game',
  dbi_pc_game: 'PC Game',
  dbi_console_game: 'Console Game',
  dbi_market_perf_sum: 'Market Performance Summary',
  dbi_market_perf_sum_tip:
    'Digital Revenue of PC & Console games is only available for US, UK, FR, DE and ES, Physical Revenue of PC & Console games is only available for US.',
  dbi_market_blockbuster: 'New Blockbuster Games',
  dbi_total_rev: 'Total Revenue',
  dbi_total_rev_$: 'Total Revenue($)',
  dbi_total_player: 'Total Players',
  dbi_market_percent: '% of Market',
  dbi_market_percent_revenue: '% of Market Revenue',
  dbi_market_percent_downloads: '% of Market Downloads',
  dbi_market_top_game: 'Top Game',
  dbi_market_top_company: 'Top Company',
  dbi_market_big_riser: 'Big Riser',
  dbi_market_cr10: 'Market CR10 By Revenue',
  dbi_market_big_riser_tips_mobile:
    'Big Riser Games are games that have entered the top list of App Store Ranks for the first time.',
  dbi_market_big_riser_tips_pc:
    'Big Riser Games are games that entered the top list of Steam Top Seller, Mscience digital revenue, and MAU for the first time.',
  dbi_market_big_riser_tips_console:
    'Big Riser Games are games that entered the top list of Store Ranks such as PS Best Selling, PS Most Downloaded, Xbox Most Played, and Xbox New Release.',
  dbi_market_blockbuster_mobile_tip:
    'Mobile games: The presented New Blockbuster Games are from the recently released Big Riser Games, which are games that have entered the top list of App Store Ranks for the first time.',
  dbi_market_blockbuster_pc_tip:
    'PC games: The presented New Blockbuster Games are from the recently released Big Riser Games, which are games that entered the top list of Steam Top Seller,Mscience digital revenue, and MAU for the first time.',
  dbi_market_blockbuster_console_tip:
    'Console games: The presented New Blockbuster Games are from the recently released Big Riser Games, which are games that entered the top list of Store Ranks such as PS Best Selling, PS Most Downloaded, Xbox Most Played, and Xbox New Release.',
  dbi_market_operation_data: 'Operation Data',
  dbi_market_by_game: 'By Games',
  dbi_market_by_genres: 'By Genres',
  dbi_market_by_companies: 'By Companies',
  dbi_market_by_main_genre: 'By Main Genre',
  dbi_market_by_sub_genre: 'By Sub Genre',
  dbi_market_tip_text:
    'The mobile metrics come from all available games within Databrain database.',
  dbi_market_tip_text_mscience:
    'Mscience daily metrics are available for the US only.',
  dbi_market_gender: 'Gender',
  dbi_market_male: 'Male',
  dbi_market_female: 'Female',
  dbi_market_other: 'Other',
  dbi_market_age_combined: 'Age Combined',
  dbi_market_education: 'Education',
  dbi_market_low: 'Low',
  dbi_market_middle: 'Middle',
  dbi_market_high: 'High',
  dbi_market_Other_no_answer: 'Other/Perfer not to answer',
  dbi_market_work_situation: 'Work situation',
  dbi_market_full_time_employee: 'Full-time employee',
  dbi_market_part_time_employee: 'Part-time employee',
  dbi_market_independent: 'Self-employed or independent',
  dbi_market_homemaker: 'Full-time homemaker',
  dbi_market_student: 'student',
  dbi_market_unemployed: 'Unemployed',
  dbi_market_Retired: 'Retired',
  dbi_market_furloughed: 'Extended or currently furloughed',
  dbi_market_esport_audience: 'Esports Audience',
  dbi_market_esport_enthusiasts: 'Esports Enthusiasts',
  dbi_market_occasional_viewers: 'Occasional Viewers',
  dbi_market_non_esport_audience: 'Non-Esports Audience',
  dbi_market_players: 'Players',
  dbi_market_total_players: 'Total Players',
  dbi_market_non_total_players: 'Non Total Players',
  dbi_market_mobile_players: 'Mobile Players',
  dbi_market_non_mobile_players: 'Non Mobile Players',
  dbi_market_pc_players: 'PC Players',
  dbi_market_non_pc_players: 'Non PC Players',
  dbi_market_console_players: 'Console Players',
  dbi_market_non_console_players: 'Non Console Players',
  dbi_market_income: 'Income',
  dbi_market_persona: 'persona',
  dbi_market_ultimate_gamer: 'The Ultimate Gamer',
  dbi_market_all_enthusiast: 'The All-Round Enthusiast',
  dbi_market_mainstream_gamer: 'The Mainstream Gamer',
  dbi_market_community_gamer: 'The Community Gamer',
  dbi_market_solo_gamer: 'The Solo Gamer',
  dbi_market_popcorn_gamer: 'The Popcorn Gamer',
  dbi_market_backseat_viewer: 'The Backseat Viewer',
  dbi_market_time_filler: 'The Time Filler',
  dbi_market_lapsed_gamer: 'The Lapsed Gamer',
  dbi_market_bargain_buyer: 'The Bargain Buyer',
  dbi_market_hardware_enthusiast: 'The Hardware Enthusiast',
  dbi_market_not_persona: 'Not a Persona',
  dbi_market_total_popular: 'Total Population',
  dbi_market_online_population: 'Online Population',
  dbi_market_top_genre: 'Top Genres',
  dbi_market_age: 'Age',
  dbi_market_total_game: 'Total game count',
  dbi_search_in_table: 'Search any {type} in the table',
  dbi_market_revenue_data_tip:
    'The Revenue and Units of MScience data in the US is rectified to half of the original amount after observing internal data.',
  dbi_market_global_tip: `Here shows the total value in global market, instead of the accumulated value of all available markets in below table.`,

  dbi_market_profile_metric_tips_gsd__gsd_totalUnits:
    'Total Units = Digital Units + Physical Units. GSD does not originally provide the Total Units. Total units is in 1-week delay and it’s net units including refund part. Note: except for the UK data, the weekly granularity data starts from Monday to Sunday. Take the sum value in selected time range.',
  dbi_market_profile_metric_tips_gsd__gsd_digitalUnits:
    "Game sales of digital copies. The data is shared by top publishers to GSD directly on their willingness. Digital units is in 1-week delay and it's net units including refund part. Note: except for the UK data, the weekly granularity data starts from Monday to Sunday. Take the sum value in selected time range.",
  dbi_market_profile_metric_tips_gsd__gsd_physicalUnits:
    "Game sales of physical copies. The data is shared by top publishers to GSD directly on their willingness. Physical units is in 1-week delay and it's net units including refund part. Note: except for the UK data, the weekly granularity data starts from Monday to Sunday. Take the sum value in selected time range.",
  dbi_market_profile_metric_tips_gsd__gsd_totalRevenue:
    'Total Revenue = Digital Revenue + Physical Revenue. GSD does not originally provide the Total Revenue. Total Revenue data may vary depending on the time period, because Physical Revenue is in 1-week delay while Digital Revenue is in 12-week delay. Note: except for the UK data, the weekly granularity data starts from Monday to Sunday. Take the sum value in selected time range.',
  dbi_market_profile_metric_tips_gsd__gsd_digitalRevenue:
    "Game revenue of digital copies. The data is shared by top publishers to GSD directly on their willingness. Digital Revenue is in 12-weeks delay and it's net revenue including refund part. Note: except for the UK data, the weekly granularity data starts from Monday to Sunday. Take the sum value in selected time range.",
  dbi_market_profile_metric_tips_gsd__gsd_physicalRevenue:
    "Game revenue of physical copies. The data is shared by top publishers to GSD directly on their willingness. Physical Revenue is in 1-week delay and it's net revenue including refund part. Note: except for the UK data, the weekly granularity data starts from Monday to Sunday. Take the sum value in selected time range.",
  dbi_market_profile_metric_tips_mscience__digitalRevenue:
    'Game revenue of digital copies made through online purchase. Take the Sum value in selected time interval.',
  dbi_market_profile_metric_tips_mscience__units:
    'Game sales of digital copies made through online purchase. Take the sum value in selected time range.',
  dbi_market_profile_metric_tips_npd__revenue:
    'Game revenue of physical copies made through offline retail purchase. Take the sum value in selected time range.',
  dbi_market_profile_metric_tips_npd__units:
    'Game revenue of physical copies made through offline retail purchase. Take the sum value in selected time range.',
  dbi_market_profile_metric_tips_newzoo__total_revenue:
    'Shown here is internally generated total annual revenue, applying only the year in the time filter.',
  dbi_market_profile_metric_tips_newzoo__total_players:
    'Shown here is internally generated total annual downloads, applying only the year in the time filter.',
};
